export const general_discussion = "النقاش العام";
export const creator_spotlight = "أضواء على المبدعين";
export const reviews = "المراجعات";
export const recommendations = "التوصيات";
export const news_updates = "الأخبار والتحديثات";
export const behind_scenes = "خلف الكواليس";
export const create_post = "إنشاء منشور";
export const write_review = "كتابة مراجعة";
export const ask_recommendation = "طلب توصية";
export const share_news = "مشاركة أخبار";
export const share_story = "مشاركة قصة";
export const post_title = "عنوان المنشور";
export const post_content = "محتوى المنشور";
export const select_category = "اختر الفئة";
export const add_tags = "إضافة علامات";
export const upload_image = "رفع صورة";
export const publish = "نشر";
export const draft = "مسودة";
export const preview = "معاينة";
export const edit_post = "تعديل المنشور";
export const delete_post = "حذف المنشور";
export const pin_post = "تثبيت المنشور";
export const unpin_post = "إلغاء تثبيت المنشور";
export const lock_post = "إغلاق المنشور";
export const unlock_post = "إلغاء إغلاق المنشور";
export const report_post = "الإبلاغ عن المنشور";
export const mark_solved = "تحديد كمحلول";
export const mark_unsolved = "تحديد كغير محلول";
export const upvote = "تصويت إيجابي";
export const downvote = "تصويت سلبي";
export const bookmark = "إضافة للمفضلة";
export const unbookmark = "إزالة من المفضلة";
export const sort_by = "ترتيب حسب";
export const filter_by = "تصفية حسب";
export const most_recent = "الأحدث";
export const most_popular = "الأكثر شعبية";
export const most_voted = "الأكثر تصويتاً";
export const most_commented = "الأكثر تعليقاً";
export const solved_only = "المحلولة فقط";
export const unsolved_only = "غير المحلولة فقط";
export const pinned_posts = "المنشورات المثبتة";
export const locked_posts = "المنشورات المغلقة";
export const no_posts_found = "لم يتم العثور على منشورات";
export const no_comments_found = "لم يتم العثور على تعليقات";
export const write_comment = "كتابة تعليق";
export const reply_to_comment = "الرد على التعليق";
export const edit_comment = "تعديل التعليق";
export const delete_comment = "حذف التعليق";
export const report_comment = "الإبلاغ عن التعليق";
export const comment_placeholder = "اكتب تعليقك هنا...";
export const reply_placeholder = "اكتب ردك هنا...";
export const search_posts = "البحث في المنشورات";
export const search_placeholder = "ابحث عن المنشورات والمواضيع...";
export const forum_rules = "قوانين المنتدى";
export const community_guidelines = "إرشادات المجتمع";
export const moderator = "مشرف";
export const admin = "مدير";
export const verified_user = "مستخدم موثق";
export const new_member = "عضو جديد";
export const active_member = "عضو نشط";
export const senior_member = "عضو كبير";
export const reputation_points = "نقاط السمعة";
export const join_date = "تاريخ الانضمام";
export const last_seen = "آخر ظهور";
export const posts_count = "عدد المنشورات";
export const comments_count = "عدد التعليقات";
export const likes_received = "الإعجابات المستلمة";
export const forum_stats = "إحصائيات المنتدى";
export const total_posts = "إجمالي المنشورات";
export const total_comments = "إجمالي التعليقات";
export const total_members = "إجمالي الأعضاء";
export const active_today = "نشط اليوم";
export const trending_topics = "المواضيع الرائجة";
export const popular_tags = "العلامات الشائعة";
export const recent_activity = "النشاط الحديث";